import { Button } from "@/components/ui/button";
import { VStack } from "@/components/ui/vstack";
import { HStack } from "@/components/ui/hstack";
import { Text } from "@/components/ui/text";
import { Center } from "@/components/ui/center";
import React, { useState, useEffect } from 'react';
import i18n from '@/assets/i18n';
import { ScrollView, TouchableOpacity } from 'react-native-gesture-handler';

const Row = ({ row, cols, onUpdate }) => {
    return (
        <HStack space='xs'>
            {[...Array(cols)].map((x, c) =>
                <Cell key={`c${c}-${row[c].emoji}`} cell={row[c]} onUpdate={onUpdate} />
            )}
        </HStack>
    );
}

const Cell = ({ cell, onUpdate }) => {

    const [emoji, setEmoji] = useState('⬛️')

    useEffect(() => {
        setEmoji(cell.emoji)
    }, [cell])

    const press = () => {
        if (emoji == '⬛️') {
            onUpdate(cell, false)
        }
    }

    const longPress = () => {
        onUpdate(cell, true)
    }

    return (
        <TouchableOpacity onPress={press} onLongPress={longPress} >
            <Text className="text-black font-[400] my--1 text-3xl leading-2xl">{emoji}</Text>
        </TouchableOpacity>
    );
}

const Board = ({ cols, rows, game }) => {

    const num = ['🟫', '1️⃣', '2️⃣', '3️⃣', '4️⃣', '5️⃣', '6️⃣', '7️⃣', '8️⃣']
    const show = ['🟥', '🟧', '🟨', '🟩', '🟦']

    const [marked, setMarked] = useState(0)
    const [hidden, setHidden] = useState(0)
    const [score, setScore] = useState(0)
    const [help, setHelp] = useState(game == 0)
    const [found, setFound] = useState(0)
    const [closed, setClosed] = useState(rows * cols)

    const newGame = () => {
        return ([...Array(rows)].map((x, r) =>
            [...Array(cols)].map((x, c) => ({ r: r, c: c, treasure: Math.random() < 0.1, near: 0, flag: false, emoji: '⬛️' })))
        )
    }

    const [cells, setCells] = useState(newGame())

    useEffect(() => {
        let board = newGame();
        let treasure = 0
        board.forEach((row, r) => {
            row.forEach((cell, c) => {
                if (cell.treasure) {
                    treasure++
                    withConnected(cell, board, incNear)
                }
            })
        })
        setMarked(0)
        setHidden(treasure)
        setScore(0)
        setFound(0)
        setClosed(rows * cols)
        setCells(board)
        setHelp(game == 0)
    }, [game])

    const update = (cell, isLong) => {
        if (closed > 0) {
            setCells(pCells => {
                let opened = 0
                let ok = 0
                let bad = 0
                let mark = 0
                let nCells = [...pCells]
                if (isLong) {
                    if (cell.emoji == '⬛️') {
                        chgCell(cell, { emoji: '🌈' }, nCells)
                        mark = 1
                        opened++
                        if (cell.treasure) {
                            ok++
                        }
                    } else if (cell.emoji == '🌈') {
                        chgCell(cell, { emoji: '⬛️' }, nCells)
                        mark = -1
                        opened--
                        if (cell.treasure) {
                            ok--
                        }
                    }
                } else {
                    if (cell.treasure) {
                        chgCell(cell, { emoji: '🌧' }, nCells)
                        bad = 1
                        opened++
                    } else {
                        opened += withConnected(cell, nCells, showCells);
                    }
                }
                setClosed(closed - opened)
                setFound(found + ok)
                setMarked(marked + mark)
                if (closed - opened == 0) {
                    //hidden: total
                    //marked + mark: all marked
                    //found + ok: all found
                    //score + bad: all lost 
                    // all found + all lost: (found + ok) - (score - bad) == hidden
                    // all marked + all lost - hidden == wrong marked: 2 * ((marked + mark) - (score - bad) - hidden)
                    setScore(score - bad + found + ok - 2 * ((marked + mark) - (score - bad) - hidden))
                    console.log('ENDE', score - bad, found + ok, marked + mark, hidden)
                } else {
                    setScore(score - bad)
                }
                return nCells
            })
        }
    }

    const chgCell = (cell, chg, nCells) => {
        nCells[cell.r][cell.c] = { ...cell, ...chg }
    }

    const incNear = (cell, nCells) => {
        cell.near++
    }

    const showCells = (cell, nCells) => {
        let cnt = 0
        if (cell.emoji == '⬛️' && !cell.treasure) {
            chgCell(cell, { emoji: cell.near == 0 ? show[Math.floor(Math.random() * show.length)] : num[cell.near] }, nCells)
            cnt++
            if (cell.near == 0) {
                cnt += withConnected(cell, nCells, showCells);
            }
        }
        return cnt
    }

    const withConnected = (cell, nCells, func) => {
        let cnt = 0
        for (let r = -1; r < 2; r++) {
            for (let c = -1; c < 2; c++) {
                if (cell.r + r > -1 && cell.r + r < rows && cell.c + c > -1 && cell.c + c < cols) {
                    cnt += func(nCells[cell.r + r][cell.c + c], nCells);
                }
            }
        }
        return cnt
    }

    return (
        <>
            {help ? (
                <Text key={'s' + marked} className="m-4 text-lg leading-2xl font-[700] text-primary-900">{i18n.t('game.help', { marked: marked, hidden: hidden })}</Text>
            ) : (
                <>
                    <Text key={'s' + marked} className="mb-2 text-xl font-[700] text-primary-900">{i18n.t('game.marked', { marked: marked, hidden: hidden })}</Text>
                    <Text key={'r' + marked + score} className="text-lg font-[500] text-primary-900">{closed == 0 ? i18n.t('game.final', { score: score, rate: Math.floor(score / hidden * 100), hidden: hidden }) : i18n.t('game.score', { score: score, closed: closed, hidden: hidden })}</Text>
                    {/* <Text key={'r' + marked + score} className="text-lg font-[500] text-primary-900">{i18n.t('game.rate', { rate: score ? Math.round(100 * marked / score) : 0, score: score })}</Text> */}
                    <ScrollView className="flex-1 m-1" bounces={false}>
                        <ScrollView horizontal className="flex-1" bounces={false}>
                            <VStack className="m-1">
                                {[...Array(rows)].map((x, r) =>
                                    <Row key={`r${r}`} row={cells[r]} cols={cols} onUpdate={update} />
                                )}
                            </VStack>
                        </ScrollView>
                    </ScrollView>
                </>
            )}
        </>
    );
}

export default function Game({ navigation }) {

    const [game, setGame] = useState(0)

    return (
        <Center className="flex-1 bg-primary-100 content-center">
            <Text className="mt-9 text-2xl font-[700] text-primary-900 mb-5">{i18n.t('game.title')}</Text>
            <Board cols={15} rows={15} game={game} />
            <Button onPress={() => setGame(game + 1)} className="my-5 bg-primary-900 mx-2 w-[95%] data-[active=true]:bg-primary-700">
                <Text className="font-[400] text-lg text-secondary-50">{i18n.t(game == 0 ? 'game.start' : 'game.restart')}</Text>
            </Button>
        </Center>
    );
}